<template>
  <div class="py-3">
    <form
      :data-id="name"
      @submit.prevent="submit">
      <div class="d-flex">
        <validated-input
          class="mr-2"
          placeholder="Label"
          label="Label"
          v-model="tempItem.label"
          :help-options="{
            content: 'Label displayed on order and in checkout.',
            html: true
          }"
        />

        <validated-input
          label="Type"
          placeholder="Type"
          type="select"
          :options="types"
          value-field="type"
          text-field="label"
          v-model="tempItem.type"
          :disabled="!tempItem.enabled"
          :help-options="{
            content: 'Type of input displayed to users and customers.',
            html: true
          }"
        />
      </div>

      <div>
        <label>Image</label>
        <div>
          <UploadButton
            v-model="tempItemImage"
            :multiple="false"
            :hasImageType="false"
            :folder="uploadFolder"
            resize="200"
          />
        </div>
      </div>
      <div v-if="tempItem.type === 'select'" class="mb-3">
        <b-tabs class="nav-tabs-underline mt-3" content-class="mt-3">
          <b-tab title="Options">
            <div>
              <label :for="'tags-basic' + uniqueKey">
                Options
                <i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content: 'Enter options to be diplayed in the select dropdown.',
                    html: true
                  }"
                ></i
              ></label>
              <b-form-tags :input-id="'tags-basic' + uniqueKey" placeholder="Add new option" v-model="tempItem.options" data-id="mPower-referenceFieldInputOptions" />
            </div>
          </b-tab>
          <b-tab title="Options Images">
            <div>
              <label>Options Image</label>
              <div>
                <UploadButton
                  v-model="tempItem.optionsImages"
                  :multiple="true"
                  :hasImageType="false"
                  :folder="uploadFolder"
                  resize="200"
                >
                  <template #actions="{ item }">
                    <div class="mb-2">
                      <label>Option</label>
                      <multiselect :multiple="false" :options="tempItem.options" v-model="item.option" />
                    </div>
                  </template>
                </UploadButton>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <div class="">
        <validated-input
          label="Description"
          placeholder="Description"
          type="text-area"
          v-model="tempItem.description"
          :disabled="!tempItem.enabled"
        />
      </div>

      <div class="mb-2" data-id="mPower-referenceFieldInputEnabled">
        <b-form-checkbox v-model="tempItem.enabled">
          {{ tempItem.target === 'order' ? 'Show in checkout' : 'Show in store' }}
          <i
            class="fas fa-question-circle text-light ml-2"
            v-b-popover.hover="{
              content: `If checked reference field will be displayed in the ${tempItem.target === 'order' ? 'checkout' : 'store'}.`
            }"
          ></i
        ></b-form-checkbox>
      </div>

      <div class="mb-2" data-id="mPower-referenceFieldInputRequired">
        <b-form-checkbox v-model="tempItem.required">
          Required
          <i
            class="fas fa-question-circle text-light ml-2"
            v-b-popover.hover="{
              content: 'If checked users will be required to enter this reference field when checking out.'
            }"
          ></i>
        </b-form-checkbox>
      </div>

      <div class="mb-2" v-if="tempItem.required">
        <label>Require based on...</label>
        <validated-input
          placeholder="Select reference fields"
          type="select"
          :options="anotherFields"
          value-field="_id"
          text-field="label"
          v-model="tempItem.requiredBasedOn"
          @change="clearRequiredBasedOnOptions"
        />
      </div>
      <div class="mb-2" v-if="requiredBasedOnFieldType === 'select'">
        <label>Require based on options...</label>
        <multiselect :multiple="true" :options="requiredBasedOnOptions" v-model="tempItem.requiredBasedOnOptions" />
      </div>

      <div class="mb-2">
        <label>Visible based on...</label>
        <validated-input
          placeholder="Select reference fields"
          type="select"
          :options="anotherFields"
          value-field="_id"
          text-field="label"
          v-model="tempItem.visibleBasedOn"
          @change="clearVisibleBasedOnOptions"
        />
      </div>
      <div class="mb-2" v-if="visibleBasedOnFieldType === 'select'">
        <label>Visible based on options...</label>
        <multiselect :multiple="true" :options="visibleBasedOnOptions" v-model="tempItem.visibleBasedOnOptions" />
      </div>

      <div v-if="isOrderReferenceField">
        <div class="mb-2">
          <b-form-checkbox v-model="tempItem.requirePayment"> Require Payment </b-form-checkbox>
        </div>
        <div class="mb-2" v-if="tempItem.requirePayment">
          <label>Require Payment based on options...</label>
          <multiselect :multiple="true" :options="tempItem.options" v-model="tempItem.requirePaymentBasedOn" />
        </div>
        <div class="mb-2">
          <b-form-checkbox v-model="tempItem.dontRequireShippingAddress"> Don’t Require Shipping Address </b-form-checkbox>
        </div>
        <div class="mb-2" v-if="tempItem.dontRequireShippingAddress">
          <label>Don’t Require Shipping Address based on options...</label>
          <multiselect :multiple="true" :options="tempItem.options" v-model="tempItem.dontRequireShippingAddressBasedOn" />
        </div>
        <div class="mb-2" v-if="tempItem.dontRequireShippingAddress">
          <b-form-checkbox v-model="tempItem.calculateTaxUsingDistributorAddress">Calculate Tax using the distributor address </b-form-checkbox>
        </div>
        <div class="mb-2">
          <b-form-checkbox v-model="tempItem.dontRequireShippingAmount"> Don’t require shipping amount </b-form-checkbox>
        </div>
        <div class="mb-2" v-if="tempItem.dontRequireShippingAmount">
          <label>Don’t require shipping amount based on options...</label>
          <multiselect :multiple="true" :options="tempItem.options" v-model="tempItem.dontRequireShippingAmountBasedOn" />
        </div>
        <div class="mb-2">
          <b-form-checkbox v-model="tempItem.linkToCustomerRoles">
            Link to customer roles
            <i
              class="fas fa-question-circle text-light ml-2"
              v-b-popover.hover="{
                content:
                  'If checked, during checkout if a customer has multiple roles and they choose a reference field that matches the role name only send approval and confirmation emails to the managers of the role that has been matched.  This helps prevent all managers of a customer from being emailed and only the manager with the related role to be copied on emails.'
              }"
            ></i
          ></b-form-checkbox>
        </div>
      </div>

      <div class="mt-4">
        <button :disabled="disabled" type="submit" class="btn btn-primary mr-2" data-id="mPower-referenceFieldSubmit">Save</button>
        <button type="button" class="btn btn-link" @click="$emit('cancel', tempItem)">Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import { refTypes } from '../../portals/utils';

export default {
  name: 'ReferenceField',
  components: {
    UploadButton: () => import('@/components/UploadButton')
  },
  data() {
    const tempItem = JSON.parse(JSON.stringify(this.referenceField));
    return {
      tempItem,
      tempItemImage: tempItem.image ? [tempItem.image] : [],
      uniqueKey: Math.random(),
      types: refTypes
    };
  },
  props: {
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      required: true
    },
    store: {
      type: Object
    },
    distributor: {
      type: Object
    },
    referenceField: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isOrderReferenceField() {
      return this.target === 'order';
    },
    uploadFolder() {
      if (this.store) {
        return `/stores/${this.store._id}/reference-fields`
      } else if (this.distributor) {
        return `/distributors/${this.distributor._id}/reference-fields`
      } else {
        return `/reference-fields`;
      }
    },
    anotherFields() {
      return this.fields
        .filter((f) => f !== this.referenceField)
        .map(({ _id, label }) => ({ _id, label: label || 'Reference Field' }));
    },
    requiredBasedOnField() {
      const { requiredBasedOn } = this.tempItem;
      return this.fields.find(({ _id }) => _id === requiredBasedOn);
    },
    requiredBasedOnFieldType() {
      return this.requiredBasedOnField?.type;
    },
    requiredBasedOnOptions() {
      return this.requiredBasedOnField?.options || [];
    },
    visibleBasedOnField() {
      const { visibleBasedOn } = this.tempItem;
      return this.fields.find(({ _id }) => _id === visibleBasedOn);
    },
    visibleBasedOnFieldType() {
      return this.visibleBasedOnField?.type;
    },
    visibleBasedOnOptions() {
      return this.visibleBasedOnField?.options || [];
    }
  },
  methods: {
    clearRequiredBasedOnOptions() {
      this.tempItem.requiredBasedOnOptions = [];
    },
    clearVisibleBasedOnOptions() {
      this.tempItem.visibleBasedOnOptions = [];
    },
    submit() {
      this.$emit('submit', {
        ...this.tempItem,
        image: this.tempItemImage[0]
      });
    }
  }
};
</script>
